import Emoticon from '@/assets/data/emoticon'
let imgUrl = process.env.NODE_ENV === 'production' ? '/webvisitor' : ''
const obj = {
  showFace: { // 显示的表情
    name: 'wx',
    type: 'svg'
  },
  encodeFace: [ // 需要转义的表情
    {
      name: 'yun',
      type: 'png'
    },
    {
      name: 'wx',
      type: 'svg'
    }
  ],
  /**
   * Function replaceFace 将表情编码转换为图片显示
   * @param {String} data 需要进行表情符号替换为的图片显示的字符串
   * 使用场景： 获取实时/历史消息时调用
   */
  replaceFace(data){
    if (!data) {
      return ''
    }
    let str = data;
    let faceTypeArray = obj.encodeFace; // 表情名称数组
    for (var i = 0; i < faceTypeArray.length; i++) {
      let faceType = faceTypeArray[i].name;
      let imageType = faceTypeArray[i].type;
      let faceArray = Emoticon[faceType]; // 获取使用的表情码数组
      if (faceType === 'wx') {
        faceArray = [...faceArray, ...Emoticon.extra]
      }
      for (let j = 0; j < faceArray.length; j++) {
        let fullFace = (faceType === 'wx' ? '' : faceType) + faceArray[j][1];
        let name
        if (faceType === 'wx') {
          name = faceArray[j][0] + '.' + imageType;
        } else {
          name = j + '.' + imageType;
        }
        let src = require(`@/assets/img/${faceType}/${name}`)
        let p = `<img class="face-image" style="width:24px;height:24px;" src=${src} class="face-image" />`
        if (str.indexOf(fullFace) + 1) {
          str = str.replaceAll(fullFace, p)
        }
      }
    }
    return str
  },

  /**
   * 将表情转化成编码
   * @param {String} string 需要发送的文字字符串
   * 使用场景，发送消息前调用
   */
  codeFace(string){
    if (!string) {
      return ''
    }
    let str = string
    let faceType = obj.showFace.name;
    let faceArray = Emoticon[faceType];
    if (faceType === 'wx') {
      faceArray = [ ...faceArray, ...Emoticon.extra ]
    }
    for (let i = 0; i < faceArray.length; i++) {
      let fullFace = faceArray[i][0]
      if (str.indexOf(fullFace) + 1) {
        str = str.replaceAll(fullFace, faceArray[i][1])
      }
    }
    return str
  },
}

export default obj
